module.exports = __webpack_public_path__ + "static/media/elo-black.68a02c12.svg";